import React from 'react';
import { Circle } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const BackgroundBlur = ({
  top,
  left,
  size = '500px',
  colorScheme = 'dark'
}) => {
  const backgroundColors = {
    light: 'rgba(225, 244, 255, 0.6)',
    dark: 'rgba(172, 231, 254, 0.5)'
  };

  return <Circle background={backgroundColors[colorScheme]} filter="blur(125px)" left={left} position="absolute" size={size} top={top} />;
};

BackgroundBlur.propTypes = {
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colorScheme: PropTypes.oneOf(['dark', 'light'])
};

export default BackgroundBlur;
